<template>
  <div class="min-h-screen grid grid-cols-12 relative">

    <img
        src="/images/glow-1.png"
        alt="glow default effect"
        class="absolute -bottom-20 z-0 right-[-0rem] w-[calc(100vw*2)] h-[70vh]"
    />

    <img
        src="/images/glow-2.png"
        alt="glow default effect"
        class="absolute -top-10 z-0 left-[-0rem] w-[calc(100vw*2)] h-[70vh]"
    />

    <div class="flex h-full relative w-screen">
      <b-sidebar v-model="openSidebar" v-if="status === 'authenticated'" />

      <div class="flex-1">
        <div class="flex items-center z-10 backdrop-blur-md fixed top-0" :class="status === 'authenticated' ? 'lg:left-sidebar lg:w-[calc(100vw-280px)]' : 'w-full'">
          <div class="h-navbar flex items-center lg:hidden px-8 border-b border-[#373737]" @click="openSidebar = !openSidebar">
            <icon name="solar:hamburger-menu-line-duotone" class="size-10 text-white" />
          </div>
          <b-navbar />
        </div>
        <div v-if="showAlerts" class="bg-[#303550] border-y border-[#393F79] px-[50px] py-2 flex items-center justify-between w-full mt-navbar overflow-y-auto" :class="isAuthenticated ? 'lg:w-[calc(100vw-280px)] lg:ml-sidebar' : 'w-full'">
          <div class="text-white text-sm flex items-center gap-4">
            <button @click="dismissAlerts">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.9996 14.1216L17.3026 19.4246C17.584 19.706 17.9657 19.8641 18.3636 19.8641C18.7616 19.8641 19.1432 19.706 19.4246 19.4246C19.706 19.1432 19.8641 18.7616 19.8641 18.3636C19.8641 17.9657 19.706 17.584 19.4246 17.3026L14.1196 11.9996L19.4236 6.69662C19.5629 6.55729 19.6733 6.39189 19.7487 6.20987C19.824 6.02785 19.8628 5.83277 19.8627 5.63577C19.8627 5.43877 19.8238 5.24371 19.7484 5.06172C19.673 4.87974 19.5624 4.71439 19.4231 4.57512C19.2838 4.43586 19.1184 4.3254 18.9364 4.25005C18.7543 4.1747 18.5592 4.13595 18.3623 4.13599C18.1653 4.13604 17.9702 4.17489 17.7882 4.25032C17.6062 4.32575 17.4409 4.43629 17.3016 4.57562L11.9996 9.87862L6.6966 4.57562C6.5583 4.43229 6.39284 4.31794 6.20987 4.23924C6.0269 4.16055 5.83009 4.11907 5.63092 4.11725C5.43176 4.11543 5.23422 4.15329 5.04984 4.22862C4.86546 4.30395 4.69793 4.41526 4.55703 4.55603C4.41612 4.6968 4.30466 4.86422 4.22916 5.04853C4.15365 5.23284 4.1156 5.43034 4.11724 5.62951C4.11887 5.82868 4.16016 6.02553 4.23869 6.20857C4.31721 6.39161 4.43141 6.55718 4.5746 6.69562L9.8796 11.9996L4.5756 17.3036C4.43241 17.4421 4.31821 17.6076 4.23969 17.7907C4.16116 17.9737 4.11987 18.1706 4.11824 18.3697C4.1166 18.5689 4.15465 18.7664 4.23016 18.9507C4.30566 19.135 4.41712 19.3024 4.55803 19.4432C4.69893 19.584 4.86646 19.6953 5.05084 19.7706C5.23522 19.846 5.43276 19.8838 5.63192 19.882C5.83109 19.8802 6.0279 19.8387 6.21087 19.76C6.39384 19.6813 6.5593 19.5669 6.6976 19.4236L11.9996 14.1216Z"
                    fill="currentColor"
                />
              </svg>
            </button>
            {{ alerts[0].message }}
          </div>
          <div>
            <BButton variant="tertiary" size="sm" class="!text-[10px] uppercase font-semibold" @click="router.push('/settings/company')">{{ $t('common.update') }}</BButton>
          </div>
        </div>

        <div class="p-[50px] min-h-[calc(100vh-80px)] w-full" :class="[isAuthenticated ? 'lg:w-[calc(100vw-280px)] lg:ml-sidebar' : 'w-full', showAlerts ? '' : 'mt-navbar']">
          <slot />
        </div>
      </div>
    </div>
  </div>
  <b-toast-list />
  <b-whatsapp-widget />

  <!-- Publish Mission Modal (for organizations) -->
  <b-modal-publish-mission
    v-if="isOrganization"
    v-model="isPublishModalOpen"
  />
</template>
<script setup lang="ts">
import BSidebar from "~/components/navigation/BSidebar.vue";
import BNavbar from "~/components/navigation/BNavbar.vue";
import BToastList from "~/components/toast/BToastList.vue";
import BWhatsappWidget from "~/components/common/BWhatsappWidget.vue";
import BModalPublishMission from "~/components/modal/mission/BModalPublishMission.vue";
import { useAuth } from "~/composables/useAuth";
import { authStore } from "~/stores/auth";
import {useDocumentStore} from "~/stores/v2/company/useDocumentStore";
import {useCompanyStore} from "~/stores/companyStore";
import BButton from "~/components/forms/BButton.vue";

const { t } = useI18n();
const openSidebar = ref(false);
const { isAuthenticated } = useAuth();

const { isOpen: isPublishModalOpen, close: closePublishModal } = usePublishMissionModal();
const auth = authStore();
const isOrganization = computed(() => auth.isOrganization);
const route = useRoute();

watch(() => route.path, () => {
  closePublishModal();
});

const documentStore = useDocumentStore();
const { documents } = storeToRefs(documentStore);

const companiesStore = useCompanyStore();
const { companies } = storeToRefs(companiesStore);

const router = useRouter();
const alerts = ref<{ message: string, url: string }[]>([])
const alertsDismissed = ref(false)

const showAlerts = computed(() => alerts.value.length > 0 && !alertsDismissed.value)

const dismissAlerts = () => {
  alertsDismissed.value = true
  if (import.meta.client) {
    sessionStorage.setItem('alerts_dismissed', 'true')
  }
}

const { status } = useAuth();

onMounted(async () => {
  if (sessionStorage.getItem('alerts_dismissed') === 'true') {
    alertsDismissed.value = true
  }

  if (companies.value && companies.value.length === 0) {
    try {
      await companiesStore.fetchCompanies()
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  }

  if (companies.value && companies.value.length > 0) {
    documentStore.fetchDocuments(companies.value[0]?.company_id).then(response => {
      if (Array.isArray(response) && response.length > 0) {
        response.forEach(element => {
          if (element.is_required && !element.document) {
            alerts.value.push({ message: `${element.name} ${t('common.document_required_suffix')}`, url: '/settings/company' })
          }
        })
      }
    })
  }
})

</script>
